// trường hợp api trả về lỗi sẽ in ra ảnh mặc định
import { fallbackImage } from '~/assets/images'

export const handleErrorImg = (e) => {
  if (!e.target.onerror) {
    e.target.src = fallbackImage
  }
}
